<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_document_number_search') || '单据编号搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="openEditPage({ pageType: 'add' })"
              v-if="allow('A')"
            >
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$l('INDEX.Status') || '有效状态'">
              <el-checkbox-group v-model="form.billStatusList">
                <el-checkbox label="N">{{
                  $l('INDEX.bill_status_new') || '未审核'
                }}</el-checkbox>
                <el-checkbox label="Y">{{
                  $l('INDEX.bill_status_reviewed') || '已审核'
                }}</el-checkbox>
                <el-checkbox label="D">{{
                  $l('INDEX.bill_status_deleted') || '作废'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('INDEX.form_label_bill_no') || '单据编号'">
              <el-input
                v-model.trim="form.stockInNo"
                :placeholder="
                  $l('INDEX.Please enter the document number') ||
                    '请输入单据编号'
                "
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_createBy') || '创建人名称'">
              <dict-select
                clearable
                v-model="form.createByList"
                filterable
                multiple
                size="small"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('tips_select_createBy') || '请选择创建人名称'"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.bill_time_create_time') || '创建日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateBegin"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="24">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.bill_time_modify_time') || '修改日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateBegin"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date' || '选择日期')"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  billStatusList: ['N', 'Y'],
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  created() {
    this.query()
    this.$eventBus.$on('sampleStockIn', () => {
      this.query()
    })
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 打开编辑页面

    openEditPage({ pageType, params }) {
      this.$router.push({
        name: 'samplemanage-sampletockIn-detail',
        params: { ...params, pageType },
      })
    },
    getForm() {
      return this.form
    },
    //时间验证
    beginDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.timeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.timeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    processDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.timeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.timeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
